export default __webpack_public_path__ + "assets/img/color-wheel.941978ee5a1dd03bfb17fbe601f21448.png";